/* 
 * Copyright (C) 2022 SHC Holdings LLC.  All Rights Reserved. 
 */
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import {
  useToggle,
  FilterSidebar,
  FilterResultDashboard,
  DemographicChartComponent,
  TrendLineComponent,
  TableViewComponent,
  MapProvider,
  FilterBar,
  MapLayerMenu,
  useViewValue,
  GeoLevelEnum,
  useFilterValue,
  LocationMenu,
  DownloadButton,
  useUIValueSessionStorage,
} from 'nmqf-common-ui';
import { IndexFilterDialog } from '../filterdialog';
import { IndexMapComponent } from '../map';
import { DataRegionOverlay } from '../filterbar';

const StyledDashboard = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;
const StyledViewMode = styled.div`
  height: 100%;
  width: 100%;
  overflow: auto;
`;

export const IndexDashboard: React.FC = () => {
  const [defaultActiveTab, setDefaultActiveTab] = useState<string>();
  const [showFilterDialog, toggleFilterDialog] = useToggle();
  const [regions, setRegions] = useUIValueSessionStorage('regions');
  const regionsRef = useRef<string[]>();
  const [geoLevel] = useViewValue('geoType');
  const [isAggregatedDataSource] = useFilterValue('isAggregatedDataSource');
  const isSupportRegions = !isAggregatedDataSource && geoLevel === GeoLevelEnum.Zip5;

  useEffect(() => {
    if (!isSupportRegions) {
      regionsRef.current = regions;
    }
    if (isSupportRegions && regionsRef.current) {
      setRegions(regionsRef.current);
    } else if (!isSupportRegions) {
      setRegions([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSupportRegions]);

  const handleToggleFilterDialog = (tabId?: string) => {
    setDefaultActiveTab(tabId);
    toggleFilterDialog();
  };

  return (
    <MapProvider>
      <StyledDashboard>
        <IndexFilterDialog isOpen={showFilterDialog} toggle={toggleFilterDialog} defaultActiveTab={defaultActiveTab} />
        <FilterBar toggleFilterDialog={handleToggleFilterDialog}>
          <MapLayerMenu>
            {isSupportRegions && <DataRegionOverlay value={regions} onChange={setRegions as any} />}
            <LocationMenu />
          </MapLayerMenu>
          <DownloadButton />
        </FilterBar>
        <FilterResultDashboard toggleFilterDialog={handleToggleFilterDialog}>
          <FilterSidebar toggleFilterDialog={handleToggleFilterDialog} />
          <StyledViewMode>
            <IndexMapComponent regions={regions} />
            <DemographicChartComponent />
            <TrendLineComponent />
            <TableViewComponent />
          </StyledViewMode>
        </FilterResultDashboard>
      </StyledDashboard>
    </MapProvider>
  );
};
